import { Close } from "@mui/icons-material";
import { FC, HTMLAttributes } from "react";
import styled from "styled-components";

interface ModalProps extends HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  showModal: boolean;
  setShowModal: (value: boolean) => void;
}

const StyledFundo = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;

  width: 100vw;
  height: 100vh;
  z-index: 1000;
  background-color: #00000010;
  backdrop-filter: blur(10px);
`;

const StyledModal = styled.div`
  background-color: ${({ theme }) => theme.background};
  padding: 10px;
  color: #000;
  border-radius: 15px;
  box-shadow: 10px 10px 20px #00000010;
  max-width: 90%;
  position: relative;
  overflow: hidden;
  overflow-y: auto;
  max-height: 800px;
`;

const StyledClose = styled.span`
  position: absolute;
  top: 10px;
  right: 10px;
  color: ${({ theme }) => theme.text};
  cursor: pointer;
  background-color: #00000010;
  padding: 8px;
  border-radius: 50%;

`;

const Modal: FC<ModalProps> = ({
  children,
  showModal,
  setShowModal,
  ...props
}) => {
  return showModal ? (
    <StyledFundo>
      <StyledModal {...props}>
        <StyledClose onClick={() => setShowModal(false)}>
          <Close />
        </StyledClose>
        {children}
      </StyledModal>
    </StyledFundo>
  ) : null;
};

export default Modal;
